import { withCartSource } from '@/lib/cart-source';
import { CustomLogger, createLogger } from '@/lib/logger';

class ProductCardForm extends HTMLElement {
  private form: HTMLFormElement | null;
  private buttonSkeleton: HTMLButtonElement | null;
  private qtyInput: HTMLInputElement | null;
  private log: CustomLogger;

  constructor() {
    super();

    this.form = null;
    this.buttonSkeleton = null;
    this.qtyInput = null;
    this.log = createLogger('product-card');

    const form = this.querySelector<HTMLFormElement>('form');

    if (!form) {
      this.log.error('Could not find form');
      return;
    }

    this.form = form;

    const buttonSkeleton = form.querySelector('.button-skeleton');

    if (!buttonSkeleton) {
      this.log.error('Could not find button skeleton');
      return;
    }

    this.buttonSkeleton = buttonSkeleton as HTMLButtonElement;

    const qtyInput = form.querySelector('input[name="qty"]');

    if (!qtyInput) {
      this.log.error('Could not find qty input');
      return;
    }

    this.qtyInput = qtyInput as HTMLInputElement;

    this.bindEvents();
  }

  showLoadingIndicator() {
    if (this.buttonSkeleton) {
      this.buttonSkeleton.classList.remove('!hidden');
    }
  }

  hideLoadingIndicator() {
    if (this.buttonSkeleton) {
      this.buttonSkeleton.classList.add('!hidden');
    }
  }

  handleSubmit(e: SubmitEvent) {
    e.preventDefault();
    this.showLoadingIndicator();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    const endpoint = `${window.Shopify.routes.root}cart/add.js`;

    let formData = {
      items: [
        {
          id: this.getAttribute('data-variant-id')!,
          quantity: parseInt(this.qtyInput!.value),
          properties: withCartSource(null, 'homepage-product-card:handleSubmit'),
        },
      ],
    };

    fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        this.log.info(data);
      })
      .catch((error) => {
        this.log.error('There was a problem with the fetch operation:', error);
      })
      .finally(() => {
        this.hideLoadingIndicator();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  bindEvents() {
    this.form!.addEventListener('submit', this.handleSubmit.bind(this));
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (customElements.get('product-card-form')) return;

  customElements.define('product-card-form', ProductCardForm);
});
